import * as Shariff from "shariff";

function initializeSocialMediaButtons(): void {
  const buttonsContainer = $(".social-media-buttons");
  if (buttonsContainer == null || buttonsContainer.length === 0) {
    return;
  }
  try {
    new Shariff(buttonsContainer);
  } catch (e) {
    console.error("Could not initialize social media buttons.", e);
  }
}

initializeSocialMediaButtons();
